import React from 'react';
import { useTranslation } from 'localization';
import { ApproachDeploymentInput, DeploymentInputType } from 'types/approach';
import { getLocalizedText } from '../../../utils/getLocalizedText';
import './DeploymentInputsSummaryMolecule.scss';

export interface DeploymentInputsSummaryMoleculeProps {
  inputs: ApproachDeploymentInput[];
  className?: string;
}

const INPUT_TYPE_I18N_MAP: Record<DeploymentInputType, string> = {
  text: 'marketplace.approachDetail.deploymentInputs.inputTypes.text',
  number: 'marketplace.approachDetail.deploymentInputs.inputTypes.number',
  date: 'marketplace.approachDetail.deploymentInputs.inputTypes.date',
  date_range: 'marketplace.approachDetail.deploymentInputs.inputTypes.dateRange',
  select: 'marketplace.approachDetail.deploymentInputs.inputTypes.select',
  person_select: 'marketplace.approachDetail.deploymentInputs.inputTypes.personSelect',
  sphere_select: 'marketplace.approachDetail.deploymentInputs.inputTypes.sphereSelect',
  boolean: 'marketplace.approachDetail.deploymentInputs.inputTypes.boolean',
};

const DeploymentInputsSummaryMolecule: React.FC<DeploymentInputsSummaryMoleculeProps> = ({
  inputs,
  className = '',
}) => {
  const { t } = useTranslation();

  const classes = ['marketplace-deployment-inputs-summary-molecule', className]
    .filter(Boolean)
    .join(' ');

  if (inputs.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <div className="marketplace-deployment-inputs-summary-molecule__header">
        <span>
          {t('marketplace.approachDetail.deploymentInputs.inputCount', {
            count: inputs.length,
          })}
        </span>
      </div>

      <div className="marketplace-deployment-inputs-summary-molecule__list">
        {inputs.map((input) => (
          <div
            key={input.id}
            className="marketplace-deployment-inputs-summary-molecule__input"
          >
            <div className="marketplace-deployment-inputs-summary-molecule__input-header">
              <i className="pi pi-pencil" />
              <span className="marketplace-deployment-inputs-summary-molecule__input-label">
                {getLocalizedText(input.label)}
              </span>
              <span
                className={`marketplace-deployment-inputs-summary-molecule__required-badge ${
                  input.required
                    ? 'marketplace-deployment-inputs-summary-molecule__required-badge--required'
                    : 'marketplace-deployment-inputs-summary-molecule__required-badge--optional'
                }`}
              >
                {input.required
                  ? t('marketplace.approachDetail.deploymentInputs.required')
                  : t('marketplace.approachDetail.deploymentInputs.optional')}
              </span>
            </div>

            <div className="marketplace-deployment-inputs-summary-molecule__input-details">
              <span className="marketplace-deployment-inputs-summary-molecule__input-type">
                {t(INPUT_TYPE_I18N_MAP[input.inputType])}
              </span>
              {input.description && (
                <span className="marketplace-deployment-inputs-summary-molecule__input-description">
                  {getLocalizedText(input.description)}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeploymentInputsSummaryMolecule;
